import { useRBAC } from '@/contexts/RBACContext';

type UserRole = 'user' | 'group_admin' | 'company_admin' | 'admin' | 'superadmin';

interface UseUserRoleReturn {
  role: UserRole | null;
  isGroupAdmin: boolean;
  isCompanyAdmin: boolean;
  isAdmin: boolean;
  isSuperadmin: boolean;
  loading: boolean;
}

/**
 * Hook to get the current user's role and permission flags
 *
 * This hook is now a thin wrapper around useRBAC for backwards compatibility.
 * The actual RBAC data fetching happens in RBACContext to prevent flickering.
 */
export function useUserRole(): UseUserRoleReturn {
  const {
    role,
    isGroupAdmin,
    isCompanyAdmin,
    isAdmin,
    isSuperadmin,
    loading,
  } = useRBAC();

  return {
    role,
    isGroupAdmin,
    isCompanyAdmin,
    isAdmin,
    isSuperadmin,
    loading,
  };
}
